import { ErrorHandler, Injectable } from '@angular/core';

import { ErrorLogService } from './error-log.service';

@Injectable()
export class LoggingErrorHandler implements ErrorHandler {
  private options = {
    rethrowError: false,
    unwrapError: false
  };

  constructor(private errorLogService: ErrorLogService) {}

  public handleError(error: any): void {
    // Send to the error-logging service.
    try {
      this.options.unwrapError
        ? this.errorLogService.logError(this.findOriginalError(error))
        : this.errorLogService.logError(error);
    } catch (loggingError) {
      console.group('ErrorHandler');
      console.warn('Error when trying to log error to', this.errorLogService);
      console.error(loggingError);
      console.groupEnd();
    }

    if (this.options.rethrowError) {
      throw error;
    }
  }

  private findOriginalError(error: any): any {
    while (error && error.originalError) {
      error = error.originalError;
    }
    return error;
  }
}

export let LOGGING_ERROR_HANDLER_PROVIDERS: any = [
  {
    provide: ErrorHandler,
    useClass: LoggingErrorHandler
  }
];
